<div class="bckStc text-center">
    <div class="image-container text-center col-md-4">
        <span> {{ 'notathAr' | translate }} </span>
        <p>{{ 'notathEn' | translate }}</p>
    </div>
    <div class="col-md-4">
        <img src="assets/images/warningNotAtho.svg" class="" alt="Image" />
    </div>
    <div class="imgstc"></div>
</div>
